<template>
    <b-row class="h-100 w-100 mh-100 no-gutters overflow-hidden" @wheel="onMouseWheel" @click="loseFocus">
        <!-- <b-card no-body class="w-100 bg-gray-light py-1 d-flex flex-column mx-2 rounded-lg" :style="'height:' + allocationHeight + '%;'"> -->
        <b-card no-body class="w-100 mx-2" :style="'height:' + allocationHeight + '%;'">
            <AllocationHeader v-if="form.Sections.filter(s => s.Name == 'Parent').length > 0" :Sections="form.Sections.filter(s => s.Name == 'Parent')" :IndexWidth.sync="indexWidth" />
            <AllocationPeriods :Sections="meterSections" :IndexWidth.sync="indexWidth" :AllocationUtils="allocationUtils" :CheckWriteAction="checkWriteAction" :CheckDeleteAction="checkDeleteAction" @AddSectionEvent="addSection" @SectionSelectedEvent="loadSection" @SectionDeletedEvent="(index, sections) => deleteSection(index, sections, 'Meter')" />
            <b-row cols="3" class="no-gutters">
                <b-col id="Column1" ref="column" class="h-100 w-100">
                    <div class="text-center mt-2" style="font-size: 1rem; font-weight: 600; line-height: 150%;">
                        {{ $t('Meter') }}
                    </div>
                </b-col>
                <b-col class="h-100 w-100 border-left border-right">
                    <div class="text-center mt-2" style="font-size: 1rem; font-weight: 600; line-height: 150%;">
                        {{ $t('UsageBreakdown') }}
                    </div>
                </b-col>
                <b-col class="h-100 w-100">
                    <div class="text-center mt-2" style="font-size: 1rem; font-weight: 600; line-height: 150%;">
                        {{ $t('Consumers') }}
                    </div>
                </b-col>
            </b-row>
            <svg id="canvasAllocation" height="100%" width="100%" ref="canvas">
                <edge v-for="edge in graph.edges" :data="edge" :nodes="graph.nodes" :key="edge.id" :style="'opacity: ' + edge.opacity">
                </edge>
                <defs>
                    <marker markerWidth="5" markerHeight="5" refX="2.5" refY="2.5" viewBox="0 0 5 5" orient="auto"
                        id="SvgjsMarker1122">
                        <polygon points="0,5 0,0 5,2.5" fill="#E9ECEF"></polygon>
                    </marker>
                </defs>
                <foreignObject height="100%" width="100%">
                    <b-row cols="3" class="h-100 w-100 no-gutters flex-1">
                        <b-col id="Column1" ref="column" class="h-100 w-100 Column">
                        </b-col>
                        <b-col class="h-100 w-100 border-left border-right Column">
                        </b-col>
                        <b-col class="h-100 w-100 Column">
                        </b-col>
                    </b-row>
                </foreignObject>
                <node :id="node.id" :data="node" :fit="false" :useDrag="false" ref="currentNode"
                    v-for="(node, index) in graph.nodes" :key="index">
                    <b-container class="p-0 m-0" @click.stop="focusNodes(node)">
                        <b-row align-v="center" class="w-100 h-100 p-0 m-0" :style="'opacity: ' + node.opacity">
                            <b-col v-if="node.column === 1" class="d-flex flex-column justify-content-center h-100 w-100 pl-2 pr-1">
                                <div class="w-100 d-flex">
                                    <b-img class="my-auto mx-3" style="height: 1.9rem; width: 1.9rem;" :src="AbsoluteLink('Icons/' + node.icon + '_Icon.svg')" />
                                    <div class="d-flex flex-column ml-1 w-75">
                                        <span class="font-weight-bold text-truncate my-auto" v-b-tooltip.hover :title="node.name" style="font-size: .75rem;">{{ node.name }}</span>
                                        <span v-if="node.invariant != ''" style="font-size: .625rem;">{{ node.invariant }}</span>
                                    </div>
                                </div>
                            </b-col>
                            <b-col v-if="node.column === 2"  class="h-100 w-100 p-0">
                                <div class="w-100 h-100 d-flex flex-column">
                                    <div class="w-100 d-flex">
                                        <span class="position-relative h-100 w-25">
                                            <i class="position-absolute" style="z-index: 2; font-size: 1.5rem; left: 52%; transform: translateX(-50%);" :class="'bi bi-' + generateUsageIcon(node.Usage)[0]" />
                                            <i class="position-absolute" v-if="generateUsageIcon(node.Usage).length > 1" style="z-index: 1; font-size: 1.5rem; left: 52%; transform: translateX(-50%);" :class="'bi bi-' + generateUsageIcon(node.Usage)[0] + '-fill text-white'" />
                                            <i class="position-absolute" v-if="generateUsageIcon(node.Usage).length > 1" style="z-index: 0; font-size: 1.5rem; left: 67%; transform: translateX(-50%);" :class="'bi bi-' + generateUsageIcon(node.Usage)[1]" />
                                        </span>
                                        <div class="d-flex flex-column w-100 my-1 ml-2 text-truncate">
                                            <span class="font-weight-bold" style="font-size: 0.75rem;">{{ generateUsageLabel(node.Usage) }}</span>
                                        </div>
                                        <div class="text-right pr-2">
                                            <i v-if="checkWriteAction" class="bi bi-gear mr-1 text-black" role="button" style="font-size: 0.875rem;" @click="openAllocations(node)"></i>
                                            <i v-if="checkDeleteAction" class="bi bi-x-lg mr-1 text-danger" role="button" style="font-size: 0.875rem;" @click="deleteNode(node.id)"></i>
                                        </div>
                                    </div>
                                    <b-progress class="w-75 position-relative mt-1 mx-auto" style="height: 0.9rem" max="100" variant="secondary">
                                        <b-progress-bar :value="node.Percentage" animated></b-progress-bar>
                                        <span class="w-100 h-100 position-absolute text-center d-flex flex-column justify-content-center" style="font-size: .75rem; font-weight: 600;" :style="node.Percentage > 53 ? 'color: #FFFFFF' : 'color: #000000'">
                                            {{ node.Percentage }}%
                                        </span>
                                    </b-progress>
                                    <span style="font-size: 0.625rem; font-weight: 300;" class="ml-4">
                                        {{ node.startDate?.getDate() }} {{ getMonth(node.startDate?.getMonth()) }} - {{ setLowerPeriod(node.endDate)?.getDate() }} {{ getMonth(setLowerPeriod(node.endDate)?.getMonth()) }}
                                    </span>
                                </div>
                            </b-col>
                            <b-col v-if="node.column === 3" class="d-flex h-100 w-100 p-0">
                                <div class="d-flex my-auto mr-auto text-truncate">
                                    <b-img class="my-auto mx-3" style="height: 1.8rem; width: 1.8rem;" :src="AbsoluteLink('Icons/' + node.icon + '_Icon.svg')" />
                                    <div class="d-flex flex-column ml-1 text-truncate">
                                        <span class="font-weight-bold text-truncate" v-b-tooltip.hover :title="node.name" style="font-size: 0.75rem;">{{ node.name }}</span>
                                        <span style="font-size: 0.625rem;">{{ node.invariant }}</span>
                                    </div>
                                </div>
                                <div class="my-auto d-flex">
                                    <div class="mx-auto py-1 px-2 bg-gray rounded-pill font-weight-bold">
                                        <div style="width: 11%;" class="text-right">{{ getConsumerPercent(node.id) }}</div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </node>
            </svg>
            <b-row cols="3" class="w-100 no-gutters flex-1">
                <b-col class="h-100 w-100">
                    <div v-if="testAllocation().length > 0" class="p-2 bg-warning-light text-warning-dark text-center position-absolute mr-2" style="bottom: 1rem; left: 2rem;">
                        <div v-for="error in testAllocation()" >
                            {{ error }}
                        </div>
                    </div>
                </b-col>
                <b-col class="h-100 w-100 border-left border-right">
                </b-col>
                <b-col class="h-100 w-100">
                    <b-button class="position-absolute d-flex" :variant="'outline-' + Variant" pill style="z-index: 2; right: 4%; bottom: 0.5rem;" @click="openTreeNodes('node');"> <!-- width: 12.5rem-->
                        <b-icon icon="plus" class="my-auto" scale="1" />
                        <div class="my-auto text-right w-100" style="font-size: .75rem;">{{ $t('NewAllocationLine') }}</div>
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
        <b-row class="w-100 no-gutters" :style="'height: ' + underMeterHeight + '%;'">
            <AllocationFooter :Sections="childMeterSections" :IndexWidth.sync="indexWidth" :AllocationUtils="allocationUtils" :ShowFooter.sync="showFooter" :CheckWriteAction="checkWriteAction" :CheckDeleteAction="checkDeleteAction" @ShowFooterEvent="changeFooter" @OpenTreeNodesEvent="openTreeNodes" @DeleteUnderMeterEvent="deleteUnderMeter" @AddSectionEvent="addSection" @SectionSelectedEvent="loadChildSection" @SectionDeletedEvent="(index, sections) => deleteSection(index, sections, 'Children')" />
        </b-row>

        <b-modal v-model="showTreeNodes" centered title-class="text-center w-100" header-class="py-0 pr-1 border-0"
            footer-class="p-0 border-0" dialog-class="heritage-modal" content-class="heritage-modal modal-background"
            body-class="mvh-100 mh-100 h-100 p-0 overflow-hidden"
            no-close-on-backdrop no-close-on-esc>
            <template #modal-header>
                <h6>{{ addOption == 'node' ? $t('MsgObjectTreeSelect') : $t('MsgUnderMeterTreeSelect') }}</h6>
            </template>
                <HeritageTree ref="AllocationHeritageTree" :Variant="Variant" :FilterTreeStore="filterTreeStore" :IsDraggable="false"
                    :ShowToolbar="true" :ShowSearchButton="false" />
            <template #modal-footer>
				<b-button @click="cancelAllocation()" :variant="'outline-' + Variant" pill>{{$t('Cancel')}}</b-button>
				<b-button @click="addNodes()" :variant="Variant" pill>{{$t('Submit')}}</b-button>
            </template>
        </b-modal>

        <b-modal id="modal" size="lg" v-model="showAllocations" header-class="d-flex flex-column pb-0" centered no-close-on-backdrop no-close-on-esc>
            <template #modal-header>
                <h6>{{ $t('NewDistribution') }}</h6>
                <b-tabs class="mt-1">
                    <b-tab :title="$t('Distribution')" active @click="showUsages = false;" :title-link-class="showUsages ? 'text-black' : 'text-' + Variant" />
                    <b-tab :title="$t('Usage')" @click="showUsages = true;" :title-link-class="showUsages ? 'text-' + Variant : 'text-black'" />
                </b-tabs>
            </template>
            <b-card no-body v-if="!showUsages" class="p-4">
                 <b-form-group 
                    :label="$t('Period')"
                    label-class="my-auto" label-cols-sm="2">
                    <div class="d-flex">
                        <b-button class="mx-1" :variant="allocationNode.value.IsRecurring ? 'outline-' + Variant : Variant" pill @click="allocationNode.value.IsRecurring = false">{{ $t('FullYear') }}</b-button>
                        <b-button class="mx-1" :variant="!allocationNode.value.IsRecurring ? 'outline-' + Variant : Variant" pill @click="allocationNode.value.IsRecurring = true">{{ $t('Customized') }}</b-button>
                    </div> 
                </b-form-group>
                <div v-if="allocationNode.value.IsRecurring">
                    <b-row>
                        <b-col cols="2" class="align-content-center">
                            <div clas="my-auto">{{ $t('Begin') }} ({{ $t('Include') }})</div>
                        </b-col>
                        <b-col cols="5" class="p-2">
                            <div>
                                <b-form-select v-model="allocationNode.value.StartMonth" size="sm">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>
                                        
                                            -- {{ $t('Month') }} --
                                        </b-form-select-option>
                                    </template>
                                    <b-form-select-option v-for="month in monthList()" :key="month.index" :value="month.index">
                                        {{ month.name }}
                                    </b-form-select-option>
                                </b-form-select>
                            </div>
                        </b-col>
                        <b-col cols="5" class="p-2">
                            <div>
                                <b-form-select v-model="allocationNode.value.StartDay" :disabled="allocationNode.value.StartMonth === undefined" size="sm">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>
                                        
                                        -- {{ $t('Days') }} --
                                    </b-form-select-option>
                                    </template>
                                    <b-form-select-option v-for="day in dayList(allocationNode.value.StartMonth)" :key="day" :value="day">
                                        {{ day }}
                                    </b-form-select-option>
                                </b-form-select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="2" class="align-content-center">
                            <div class="my-auto">{{ $t('End') }} ({{ $t('Include') }})</div>
                        </b-col>
                        <b-col cols="5" class="p-2">
                            <div>
                                <b-form-select v-model="allocationNode.value.EndMonth" size="sm">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>
                                        
                                        -- {{ $t('Month') }} --
                                    </b-form-select-option>
                                    </template>
                                    <b-form-select-option  v-for="month in monthList()" :key="month.index" :value="month.index">
                                        {{ month.name }}
                                    </b-form-select-option>
                                </b-form-select>
                            </div>
                        </b-col>
                        <b-col cols="5" class="p-2">
                            <div>
                                 <b-form-select v-model="allocationNode.value.EndDay" :disabled="allocationNode.value.EndMonth === undefined" size="sm">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>

                                            -- {{ $t('Days') }} --
                                        </b-form-select-option>
                                    </template>
                                    <b-form-select-option v-for="day in dayList(allocationNode.value.EndMonth)" :key="day" :value="day">
                                        {{ day }}
                                    </b-form-select-option>
                                </b-form-select>
                            </div>
                        </b-col>
                    </b-row>
                     <b-row>
                        <div class="w-100 text-center" v-if="allocationNode.value.StartMonth != undefined || allocationNode.value.EndMonth" v-html="$t('RecurencePeriod', { startDay: allocationNode.value.StartDay, startMonth: getMonth(allocationNode.value.StartMonth), endDay: allocationNode.value.EndDay, endMonth: getMonth(allocationNode.value.EndMonth) })" />
                    </b-row>
                </div>
                <b-form class="mt-1" @submit.stop.prevent>
                    <b-form-group :label="$t('AllocatedVolume')">
                        <b-row>
                            <b-col cols="9" class="my-auto">
                                <input type="range" class="w-100" variant="secondary" id="formControlRange" min="0" max="100" step="1" v-model="allocationNode.value.Percentage" />
                            </b-col>
                            <b-col cols="3" class="my-auto">
                                <b-form-input type="number" min="0" max="100" step="1" class="p-0 text-center" @keydown.enter="addAllocations()" @change="regexValue" v-model.value="allocationNode.value.Percentage" />
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-form>
            </b-card>
            <b-card no-body v-else class="p-4">
                <div class="w-100 d-flex align-content-center">
                    <div class="font-weight-bold my-auto" style="font-size: 0.9rem;">{{ $t('ChooseUsage') }}</div>
                    <div class="mx-1 my-auto">{{ $t('DefaultUndefined') }}</div>
                </div>
                <div class="d-flex justify-content-center align-items-center my-2">
                    <b-row>
                        <b-col cols="3" v-for="usage in listUsages" :key="usage.Id" class="p-1" style="height: 6.8rem">
                            <div class="h-100 p-3" style="cursor: pointer; border-radius: 0.8rem; width: 90%;" :class="usage.Id === allocationNode.value.Usage ? 'bg-primary-light text-secondary' : 'bg-white text-black'" @click="addUsage(usage.Id)">
                                <div class="d-flex h-100">
                                    <div class="d-flex align-items-center">
                                        <b-icon v-if="usage.Id === allocationNode.value.Usage" icon="check-circle-fill" />
                                        <b-icon v-else icon="record" />
                                    </div>
                                    <div class="d-flex flex-column h-100 w-100">
                                        <span class="position-relative h-100 w-100">
                                            <i class="position-absolute" style="z-index: 2; font-size: 1.8rem; left: 50%; transform: translateX(-50%);" :class="'bi bi-' + generateUsageIcon(usage.Id.toString())[0]" />
                                            <i class="position-absolute" v-if="generateUsageIcon(usage.Id.toString()).length > 1" style="z-index: 1; font-size: 1.8rem; left: 50%; transform: translateX(-50%);" :class="['bi bi-' + generateUsageIcon(usage.Id.toString())[0] + '-fill ', usage.Id === allocationNode.value.Usage ? 'text-primary-light' : 'text-white']" />
                                            <i class="position-absolute" v-if="generateUsageIcon(usage.Id.toString()).length > 1" style="z-index: 0; font-size: 1.8rem; left: 57%; transform: translateX(-50%);" :class="'bi bi-' + generateUsageIcon(usage.Id.toString())[1]" />
                                        </span>
                                        <div class="mt-auto text-center" style="font-size: .625rem; font-weight: 400;">{{ generateUsageLabel(usage.Id.toString()) }}</div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </b-card>
            <template #modal-footer>
                <b-button @click="cancelAllocation()" :variant="'outline-' + Variant" pill>{{$t('Cancel')}}</b-button>
				<b-button @click="addAllocations()" :variant="Variant" pill>{{$t('Submit')}}</b-button>
            </template>
        </b-modal>
        
    </b-row>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import locales from "./locales/Allocation.json";
import HeritageTree from '@/components/commons/HeritageTree.vue';
import TreeNode from '@/types/TreeNode';
import { FilterTreeBuilder } from '@/components/commons/FilterTreeBuilder';
import { LinkUtils } from '@/components/commons/Utils';
import { Screen, Node, Edge, graph, Port } from 'vnodes';
import 'vue-cute-timeline/dist/index.css';
import FormDraft from "@/types/fields/FormDraft";
import { MAIN_FILTER_TREE, SELECTOR_FILTER_TREE } from "@/App.settings";
import ListItem from '@/types/fields/ListItem';
import GraphEdge from '@/types/fields/GraphEdge';
import GraphNode from '@/types/fields/GraphNode';
import Section from '@/types/fields/Section';
import FieldTypeEnum from '@/enums/fields/FieldTypeEnum';
import Dictionary from '@/types/Dictionary';
import IField from '@/interfaces/IField';
import Period from '@/types/Period';
import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
import { BaseObjectForm } from './BaseObjectForm';
import IConfigTree from '@/interfaces/IConfigTree';
import AllocationUtils from './Allocation/AllocationUtils';
import AllocationHeader from './Allocation/AllocationHeader.vue';
import AllocationPeriods from './Allocation/AllocationPeriods.vue';
import AllocationFooter from './Allocation/AllocationFooter.vue';
import SelectModeEnum from '@/enums/SelectModeEnum';
import Pin from '@/types/FilterTree/Pin';

@Component({
    components: {
        HeritageTree,
        Screen,
        Node,
        Edge,
        Port,
        AllocationUtils,
        AllocationHeader,
        AllocationPeriods,
        AllocationFooter,
        'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
    },
    i18n: { messages: locales }
})
export default class Allocation extends mixins(LinkUtils, BaseObjectForm<FormDraft<Section<Period, Dictionary<IField[]>>>>) {
    private selectModeEnum = SelectModeEnum;

    private checkAddAction: boolean;
    private checkWriteAction: boolean;
    private checkDeleteAction: boolean;

    private meterSections: Section<Period, Dictionary<IField[]>>[] = [];
    private childMeterSections: Section<Period, Dictionary<IField[]>>[] = [];
    private allocationUtils: AllocationUtils = {} as AllocationUtils;

    //#region SVG

    private graph: graph = new graph();
    private scrollMove: Dictionary<number> = {};
    private inFocus: boolean = false;

    /**
     * Scroll sur une colonne
     * @param event 
     */
    private onMouseWheel(event) 
    {
        const _delta = event.deltaY;
        
        var _targetElement: HTMLElement = event.target;

        // Left Column et Right Column : Position de la souris
        let _leftColumn: number = _targetElement.offsetLeft;
        let _rightColumn: number = _leftColumn + _targetElement.offsetWidth;

        // Si l'élement sélectionné n'est pas l'element Column
        if(!event.target.classList.value.includes("Column"))
        {
            _targetElement = this.getParentElement("foreignObject", _targetElement);

            if(_targetElement === null) return;
            // Récupère la position x et y de l'élément foreignObject plutôt que celui de la souris
            let _svgElement: SVGForeignObjectElement = _targetElement as unknown as SVGForeignObjectElement;
            _leftColumn = _svgElement.x.animVal.value;
            _rightColumn = _leftColumn + _svgElement.width.animVal.value;
        }

        let _column: number = 0;
        // Pour chaque Colonne
        let _collectionHtml : HTMLCollection = document.getElementsByClassName("Column");
        for(let i = 0; i < _collectionHtml.length; i++)
        {
            let _element: HTMLElement = _collectionHtml[i] as HTMLElement;
            // Si la position de la souris est comprise dans la colonne
            if(_leftColumn >= _element.offsetLeft && _rightColumn <= _element.offsetLeft + _element.offsetWidth)
            {
                // On récupère les position de x et y de la colonne
                _column = i + 1;
                if(this.scrollMove[_column] === undefined)
                    this.scrollMove[_column] = 0;
                break;
            }
        }

        // Récupère les nodes de la colonne
        let _filterColumn = this.graph.nodes.filter(u => u.column === _column);

        if(_filterColumn.length > 0)
        {
            // Récupère la valeur y min et max
            let _minY: number = _filterColumn.map(u => Number(u.y)).sort((a, b) => { return a - b})[0];
            let _maxY: number = _filterColumn.map(u => Number(u.y)).sort((a, b) => { return b - a})[0];

            // Récupère la hauteur des nodes qui est censé rester fixe
            let _minH: number = _filterColumn.filter(u => u.y === _minY)[0].height;
            let _maxH: number = _filterColumn.filter(u => u.y === _maxY)[0].height;
            
            // Récupère la position min et max possible
            // + 10 pour garder une marge
            let _minPos: number = 0 + _minH + 10;
            let _maxPos: number = this.canvasHeight - _maxH - 10;
            
            if (_delta > 0) 
            {
                // Scroll down
                // Si le node est au dessus de la position min on continue de le déplacer
                if(_maxY > _maxPos)
                {
                    _filterColumn.forEach(node => 
                    {
                        this.graph.updateNode(node, {y: node.y - 15});
                    });
                    this.scrollMove[_column] -= 15;
                }
            } 
            else 
            {
                // Scroll up
                // Si le node est en dessous de la position max on continue de le déplacer
                if(_minY < _minPos)
                {
                    _filterColumn.forEach(node => 
                    {
                        this.graph.updateNode(node, {y: node.y + 15});
                    });
                    this.scrollMove[_column] += 15;
                }
            }
        }
    }

    /**
     * Rajoute une transparence sur les autres noeuds et edges
     * @param node 
     */
    private focusNodes(node)
    {
        this.graph.nodes.forEach(node => 
        {
            this.graph.updateNode(node, {opacity: 1});
        })

        this.graph.edges.forEach(edge => 
        {
            this.graph.updateEdge(edge, {opacity: 1});
        })
        
        // récupère tous les noeuds en lien avec le noeud clické
        let _childNodes = this.getChildNodes([], this.graph.edges.filter(u => u.to == node.id));
        let _parentNodes = this.getParentNodes([], this.graph.edges.filter(u => u.from == node.id));

        // Fusionne les nodes
        let nodes = [..._childNodes, ..._parentNodes, node];
    
        // Pour chaque noeuds qui ne sont pas en lien, passe l'opacité a 0.2
        this.graph.nodes.forEach(node => {
            if(!nodes.includes(node) && !node.nodeType){
                this.graph.updateNode(node, {opacity: 0.2});
                // Pour chaque edge en lien avec le noeud, passe l'opacité a 0.2
                this.graph.edges.filter(edge => edge.from == node.id || edge.to == node.id).forEach(u => {
                    this.graph.updateEdge(u, {opacity: 0.2});
                })
            }
        });

        // Passe le focus a true
        this.inFocus = true;
    }

    private loseFocus()
    {
        if(this.inFocus)
        {
            this.graph.nodes.forEach(node => 
            {
                this.graph.updateNode(node, {opacity: 1});
            })

            this.graph.edges.forEach(edge => 
            {
                this.graph.updateEdge(edge, {opacity: 1});
            })

            this.inFocus = false;
        }
    }

    /**
     * Récupère tous les noeuds enfants d'un noeud
     * @param nodes 
     * @param edges 
     * @returns {GraphNode[]}
     */
    private getChildNodes(nodes, edges)
    {
        // Pour chaque edges
        edges.forEach(edge =>
        {
            // Je récupère les nodes enfants
            let _childNodes = this.graph.nodes.filter(u => u.id == edge.from);
            // Pour chaque nodes enfants
            _childNodes.forEach(node => 
            {
                // Si le node n'est pas déjà dans la liste
                if(!nodes.includes(node))
                {
                    // Je l'ajoute
                    nodes.push(node);

                    // Je récupère les edges enfants
                    let _childEdges = this.graph.edges.filter(u => u.to == node.id);
                    // Si il y a des edges enfants
                    if(_childEdges.length > 0)
                    {
                        // Je rappelle la fonction pour récupérer les nodes enfants
                        this.getChildNodes(nodes, _childEdges);
                    }
                }
            })
        })

        // Je retourne la liste des nodes
        return nodes;
    }

    /**
     * Récupère tous les noeuds parents d'un noeud
     * @param nodes 
     * @param edges 
     * @returns {GraphNode[]}
     */
    private getParentNodes(nodes, edges)
    {
        // Pour chaque edges
        edges.forEach(edge =>
        {
            // Je récupère les nodes parents
            let _parentNodes = this.graph.nodes.filter(u => u.id == edge.to);
            // Pour chaque nodes parents
            _parentNodes.forEach(node => 
            {
                // Si le node n'est pas déjà dans la liste
                if(!nodes.includes(node))
                {
                    // Je l'ajoute
                    nodes.push(node);

                    // Je récupère les edges parents
                    let _parentEdges = this.graph.edges.filter(u => u.from == node.id);
                    // Si il y a des edges parents
                    if(_parentEdges.length > 0)
                    {
                        // Je rappelle la fonction pour récupérer les nodes parents
                        this.getParentNodes(nodes, _parentEdges);
                    }
                }
            })
        })

        // Je retourne la liste des nodes
        return nodes;
    }

    /**
     * Récupère l'élément parent de l'élément actuel
     * @param nodeName : nom du noeud à récupérer
     * @param element : element actuel
     * @returns {HTMLElement} : l'élément parent du noeud
     */
    private getParentElement(nodeName: string, element: HTMLElement) : HTMLElement 
    {
        if(!element) return null;

        if(element.nodeName.toLowerCase().includes(nodeName.toLowerCase()))
        {
            return element as HTMLElement;
        }
        else return this.getParentElement(nodeName, element.parentElement);
    }
 
    public allocationHeight: number = 90;
    public underMeterHeight: number = 5;
    public showFooter: boolean = false;
    private canvasWidth: number = 0;
    private canvasHeight: number = 0;
    private columnWidth: number = 0;

    private changePos() : void
    {
        this.graph.nodes.forEach(element => 
        {
            this.graph.updateNode(element, { x: ((this.columnWidth * element.column) + 10 - this.columnWidth) + (this.columnWidth - 10) * 0.21, width:  this.columnWidth * 0.60 })
        });

        this.calculateYPos();
    }

    private getIndexWidth() : void
    {
        let _divide: number = this.canvasWidth / 230;
        let _round: number = Math.floor(_divide);
        this.indexWidth = _divide - _round > 0.5 ? _round : _round - 1;
    }

    private changeFooter() : void
    {
        this.showFooter = !this.showFooter;
        this.allocationHeight = this.showFooter ? 70 : 90;
        this.underMeterHeight = this.showFooter ? 25 : 5;
    }

    /** Builder d'instance d'arborescence */
    private filterTreeBuilder!: FilterTreeBuilder;

    /** Nom de l'instance d'arborescence à créer */
    private filterTreeStore: string = SELECTOR_FILTER_TREE;

    private addOption: string = '';
    private showTreeNodes: boolean = false;

    private async openTreeNodes(option?: string) : Promise<any>
    {
        this.addOption = option;
        this.showTreeNodes = true;
        
        /** Indique le nom de l'instance de FilterTree à utiliser comme base de clonage pour tous les composants enfants du Workbench */
        if (!this.filterTreeBuilder) {
            this.filterTreeBuilder = new FilterTreeBuilder(this.$store, this.filterTreeStore);
            await this.filterTreeBuilder.Clone(MAIN_FILTER_TREE, undefined, new AllocationConfigTree(['LO', 'LBO']), SelectModeEnum.Single);
        }

        /** Ouvre le noeud ouvert dans la fiche objet */
        let node: TreeNode = this.$store.getters[this.filterTreeStore + "/Node"](this.NodeId);

        /** Ouvre le noeud sélectionné puis remonte sur son plus proche */
        this.$store.dispatch(this.filterTreeStore + "/OpenNode", { node: node, scrollIntoView: true }).then(() => {
            // Récupère le premier LBO parent du noeud
            let parentNode: TreeNode = this.$store.getters[this.filterTreeStore + '/AncestorNode']({ childNodeId: node, prefixType: 'LBO' });
            if (parentNode) 
            {
                setTimeout(() => 
                {
                    Vue.nextTick(() => 
                    {
                        this.$store.dispatch(this.filterTreeStore + "/OpenNode", { node: parentNode, scrollIntoView: true });
                    });
                }, 100);
            }
        });
    }

    private closeTreeNodes() 
    {
        this.showTreeNodes = false;
    }

    private addNodes() : void
    {
        let pins: Pin[] = this.$store.getters[this.filterTreeStore + '/GetPins'];
        let node: TreeNode = pins[0].TreeNode;

        let _error: string = '';
        if(this.addOption === 'node')
        {
            if(node.ObjectType.includes('LBO_'))
            {
                this.allocationNode.key = node.Id;
                this.openAllocations();
            } 
            else 
            {
                _error = this.$t('LocalizedBusinessObject').toString();
            }
        } 
        else if (this.addOption === 'under')
        {
            if(node.ObjectType.includes('Equipment_') && node.ObjectType.includes('UnderMeter'))
            {
                this.addUnderMeter(node.Id);
            }
            else
            {
                _error = this.$t('UnderMeter').toString();
            }
        }

        this.closeTreeNodes();

        if(_error !== '')
        {
            this.$bvToast.toast(this.$t('PleaseSelect').toString() + ' ' + _error, 
            {
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        };
    }

    private showAllocations: boolean = false;
    private indexAllocation: number = 0;
    private allocationNode: {key: string, value: TAllocation} = {key: '', value: new TAllocation()};
    
    private openAllocations(node?) : void
    {
        this.showAllocations = true;
        this.allocationNode.value = new TAllocation();

        if(node)
        {
            let _startDay: number = node.startDay;
            let _startMonth: number = node.startMonth;
            let _endDay: number = node.endDay;
            let _endMonth: number = node.endMonth;
            let _currentYear: number = new Date().getFullYear();

            let _startDate: Date = new Date(_currentYear, _startMonth, _startDay);
            let _endDate: Date = new Date(_currentYear, _endMonth, _endDay);
            
            _endDate.setDate(_endDate.getDate() - 1);

            this.allocationNode.value.Id = node.id;
            this.allocationNode.value.Percentage = node.Percentage;
            this.allocationNode.value.Usage = node.Usage;
            this.allocationNode.value.IsRecurring = node.IsRecurring;
            this.allocationNode.value.StartDay = _startDate?.getDate();
            this.allocationNode.value.StartMonth = _startDate?.getMonth();
            this.allocationNode.value.EndDay = _endDate?.getDate();
            this.allocationNode.value.EndMonth = _endDate?.getMonth();
        } 
        else 
        {
            this.allocationNode.value.Percentage = 100;
            this.allocationNode.value.IsRecurring = false;
        }
    }

    private testAllocation() : string[]
    {
        let _testError: string[] = [];
        let _allocationDates: { startDate: Date, endDate: Date, value: number }[] = []; 
        let _listDate: Date[] = [];
        let _listValue: { startDate: Date, endDate: Date, value: number }[] = [];

        this.graph.nodes.filter(u=> u.column === 2).forEach(node => 
        {
            let _startDate: Date = new Date(node.startDate.getFullYear(), node.startDate.getMonth(), node.startDate.getDate());
            let _endDate: Date =  new Date(node.endDate.getFullYear(), node.endDate.getMonth(), node.endDate.getDate());;

            if(!(_startDate.getTime() < _endDate.getTime()))
            {
                _startDate.setFullYear(_startDate.getFullYear() - 1); 
            }

            _allocationDates.push({startDate: _startDate, endDate: _endDate, value: node.Percentage});

            if(_listDate.filter(u => u?.getTime() === _startDate?.getTime()).length === 0)
                _listDate.push(_startDate);
            
            if(_listDate.filter(u => u?.getTime() === _endDate?.getTime()).length === 0)
                _listDate.push(_endDate);
        })

        _listValue = this.calculateAllocationPeriods(_listDate, _allocationDates);

        _listValue.filter(u=> Math.round(u.value * 1000000) / 1000000 != 100).forEach(value => 
        {
            if(value.startDate.getDate() === 29 && value.startDate.getMonth() === 1)
                value.startDate.setDate(value.startDate?.getDate() - 1)

            if(value.endDate.getDate() === 29 && value.endDate.getMonth() === 1)
                value.endDate.setDate(value.endDate?.getDate() - 1)

                let _startDateDay: number = value.startDate.getDate();
                let _startDateMonth: string = this.getMonth(value.startDate.getMonth());
                let _endDateDay: number = value.endDate.getDate();
                let _endDateMonth: string = this.getMonth(value.endDate.getMonth());
                let _allocPercentVal: string = (Math.round(value.value * 1000000) / 1000000).toString();

            _testError.push(this.$t('ErrorTestAllocation',
            { 
                startDateDay: _startDateDay,
                startDateMonth: _startDateMonth,
                endDateDay: _endDateDay,
                endDateMonth: _endDateMonth,
                allocPercentVal: _allocPercentVal
            }).toString());
        })

        return _testError;
    }

    private setLowerPeriod(date: Date) : Date
    {
        let _endMonth: number = date.getMonth();
        let _endDay: number = date.getDate();
        let _currentYear: number = new Date().getFullYear();

        if(_endMonth == 0)
            _currentYear++;

        let _endDate: Date = new Date(_currentYear, _endMonth, _endDay);

        _endDate.setDate(_endDate.getDate() - 1);

        return _endDate;
    }

    private dayList(monthName: number) : number[]
    {
        let _days: number[] = [];
        let _maxDays: number = 31;

        switch(monthName)
        {
            case 1:
                _maxDays = 28;
                break;
            case 3:
            case 5:
            case 8:
            case 10:
                _maxDays = 30;
                break;
            default:
                _maxDays = 31;
        }

        for (let i = 1; i <= _maxDays; i++)
        {
            _days.push(i);
        }

        return _days;
    }

    private monthList() : { index: number, name: string }[]
    {
        let _months: { index: number, name: string }[] = [];

        for (let i = 0; i < 12; i++) 
        {
            const date = new Date(0, i);
            const monthName = date.toLocaleString('default', { month: 'long' });
            _months.push({ index: i, name: monthName });
        }

        return _months;
    }

    private getMonth(index: number) : string
    {
        let _date: Date = new Date(0, index);
        return index != undefined ? _date.toLocaleString('default', { month: 'long' }) : '';
    }

    private regexValue(event) : void
    {
        if(event !== "" && event <= 100)
        {
            this.allocationNode.value.Percentage = event;
        } 
        else 
        {
            this.allocationNode.value.Percentage = 0;
        }
    }

    private addAllocations() : void
    {
        if(this.allocationNode.value.Percentage != 0)
        {
            let _currentYear: number = new Date().getFullYear();
            let _startDate: Date = new Date(_currentYear, this.allocationNode.value.StartMonth, this.allocationNode.value.StartDay)
            let _endDate: Date = new Date(_currentYear, this.allocationNode.value.EndMonth, this.allocationNode.value.EndDay);

            let _startDay: number = 0;
            let _startMonth: number = 0;
            let _endDay: number = 0;
            let _endMonth: number = 0;

            if(this.allocationNode.value.StartDay === undefined || this.allocationNode.value.StartMonth === undefined || this.allocationNode.value.EndDay === undefined || this.allocationNode.value.EndMonth === undefined)
                this.allocationNode.value.IsRecurring = false;

            if(this.allocationNode.value.IsRecurring)
            {
                _endDate.setDate(_endDate.getDate() + 1);

                _startDay = _startDate?.getDate();
                _startMonth = _startDate?.getMonth() + 1;
                _endDay = _endDate?.getDate();
                _endMonth = _endDate?.getMonth() + 1;
            }

            if(this.allocationNode.value.Id === undefined)
            {
                this.allocationNode.value.Id = (--this.indexAllocation).toString();
                (this.meterSections.find(u => u.Value.Selected == true).Fields[edgesField] as GraphEdge[]).push(new GraphEdge('METER', 'o1', this.allocationNode.value.Id , 'i1'));
                (this.meterSections.find(u => u.Value.Selected == true).Fields[edgesField] as GraphEdge[]).push(new GraphEdge(this.allocationNode.value.Id, 'o1', this.allocationNode.key, 'i1'));
            }

            let _allocation: TAllocation = { Id: this.allocationNode.value.Id, IsRecurring: this.allocationNode.value.IsRecurring, Usage: this.allocationNode.value.Usage, Percentage: this.allocationNode.value.Percentage, StartDay: _startDay, StartMonth: _startMonth, EndDay: _endDay, EndMonth: _endMonth } as TAllocation;

            let _graphNode: GraphNode<TAllocation>[] = [new GraphNode<TAllocation>(this.allocationNode.value.Id, ['i1'], ['o1'], 2, _allocation)];

            let _graphConsumers: GraphNode = (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode[]).find(u => u.Column === 3 && u.Id === this.allocationNode.key);

            if(this.allocationNode.key !== '' && _graphConsumers === undefined)
            {
                _graphNode.push(new GraphNode(this.allocationNode.key, ['i1'], ['o1'], 3))
            }
            
            this.updateNode(_graphNode);
        } 
        else 
        {
            this.$bvToast.toast(this.$t('ErrorAddDistribution').toString(), 
            {
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }
        this.showUsages = false;
        this.showAllocations = false;
    }

    private cancelAllocation()
    {
        this.showTreeNodes = false;
        this.showUsages = false;
        this.showAllocations = false;
    }

    private calculateAllocationPeriods(listDate: Date[], allocationDates: { startDate: Date, endDate: Date, value: number }[])
    {
        let _listValue: { startDate: Date, endDate: Date, value: number }[] = [];
        let _listPeriods: { startPeriod: Date, endPeriod: Date}[] = []; 

        if(listDate.length > 0 && allocationDates.length > 0)
        {
            listDate.sort((a, b) => { return a?.getTime() - b?.getTime() });

            listDate.forEach((date, index) => 
            {
                if(index !== listDate.length - 1)
                {
                    if(date?.getTime() !== listDate[index + 1]?.getTime())
                        _listPeriods.push({ startPeriod: date, endPeriod: listDate[index + 1]})
                }
            })

            allocationDates.forEach(date => 
            {
                _listPeriods.forEach(period => 
                {
                    if(date.startDate?.getTime() <= period.startPeriod?.getTime() && date.endDate?.getTime() >= period.endPeriod?.getTime())
                    {
                        if(_listValue.filter(u=> u.startDate?.getTime() === period.startPeriod?.getTime()).length === 0)
                        {
                            let _endDate: Date = this.setLowerPeriod(period.endPeriod);
                            _listValue.push({ startDate: period.startPeriod, endDate: _endDate, value: +date.value })   
                        }
                        else
                        {
                            _listValue.find(u=> u.startDate?.getTime() === period.startPeriod?.getTime()).value += +date.value;
                        }
                    }
                })
            })

            _listValue.forEach(value => 
            {
                let _startValueDate: Date = new Date(value.startDate.getFullYear(), value.startDate.getMonth(), value.startDate.getDate());
                let _endValueDate: Date = new Date(value.endDate.getFullYear(), value.endDate.getMonth(), value.endDate.getDate());

                _startValueDate.setFullYear(_startValueDate.getFullYear() + 1)

                if(_listValue.filter(u => u.startDate.getTime() === _startValueDate.getTime() && u.endDate.getTime() === _endValueDate.getTime()).length > 0)
                {
                    _listValue.filter(u => u.startDate.getTime() === _startValueDate.getTime() && u.endDate.getTime() === _endValueDate.getTime()).forEach(u => 
                    {
                        u.value += value.value;
                    })

                    _listValue.splice(_listValue.findIndex(u => u === value), 1);
                }
            })

            if (_listValue?.length > 0) 
            {
                let _minListValue: {startDate: Date, endDate: Date, value: number} = JSON.parse(JSON.stringify(_listValue.find(u => u.startDate.getTime() === Math.min(..._listValue.map(u => u.startDate.getTime())))));
                let _maxListValue: {startDate: Date, endDate: Date, value: number} = JSON.parse(JSON.stringify(_listValue.find(u => u.endDate.getTime() === Math.max(..._listValue.map(u => u.endDate.getTime())))));

                _maxListValue.endDate = new Date(JSON.parse(JSON.stringify(_maxListValue?.endDate)));
                
                if(new Date(_minListValue?.startDate)?.getTime() <= new Date(_maxListValue?.endDate?.setFullYear(_maxListValue?.endDate?.getFullYear() - 1)).getTime())
                {
                    _listValue.push({startDate: new Date(_maxListValue.endDate), endDate: new Date(_minListValue.startDate), value: +_maxListValue.value + +_minListValue.value})
                }
            }
        }

        return _listValue;
    }

    /**
     * Récupère le pourcentage d'affectation d'un consommateur
     * @param id : id du consommateur
     * @returns { string } : pourcentage d'affectation
     */
    private getConsumerPercent(id: string)
    {
        let _percentLabel: string = '';

        let _edges: GraphEdge[] = (this.meterSections.find(u => u.Value?.Selected == true)?.Fields[edgesField] as GraphEdge[])?.filter(u => u.To === id);

        let _nodes = []
        _edges?.forEach(u => 
        {
            let _graphNode = this.graph.nodes.find(x => x.id === u.From);
            _nodes.push(_graphNode);
        })

        if(_nodes.length > 0)
        {
            let _allocationDates: { startDate: Date, endDate: Date, value: number }[] = []; 
            let _listDate: Date[] = [];
            let _listValue: { startDate: Date, endDate: Date, value: number }[] = [];

            _nodes.forEach(node => 
            {
                if(node)
                {
                    let _startDate: Date = new Date(node.startDate.getFullYear(), node.startDate.getMonth(), node.startDate.getDate());
                    let _endDate: Date =  new Date(node.endDate.getFullYear(), node.endDate.getMonth(), node.endDate.getDate());

                    if(!(_startDate.getTime() < _endDate.getTime()))
                    {
                        _startDate.setFullYear(_startDate.getFullYear() - 1); 
                    }

                    _allocationDates.push({startDate: _startDate, endDate: _endDate, value: node.Percentage});

                    if(_listDate.filter(u => u?.getTime() === _startDate?.getTime()).length === 0)
                        _listDate.push(_startDate);

                    if(_listDate.filter(u => u?.getTime() === _endDate?.getTime()).length === 0)
                        _listDate.push(_endDate);   
                }
            })

            _listValue = this.calculateAllocationPeriods(_listDate, _allocationDates);

            if (_listValue && _listValue.length > 0) 
            {
                _listValue.sort((a, b) => { return a.value - b.value});

                if(_listValue.length > 1 && _listValue[0].value !== _listValue[_listValue.length - 1].value)
                    _percentLabel = Math.max(..._listValue.map(u => u.value)) + ' %';
                else _percentLabel = _listValue[0].value + ' %';
            }
        }
    
        return _percentLabel;
    }

    private listUsages: ListItem[] = [];
    private usageIcons: ListItem[] = [];
    private showUsages: boolean = false;

    private generateUsageLabel(id: string)
    {
        let _usageLabel: string = undefined;

        if(id !== undefined)
            _usageLabel = this.listUsages.filter(u => u.Id.toString() === id.toString())[0]?.Label;

        if(_usageLabel !== undefined)
            return _usageLabel;
        else return this.$t('Undefined') // 'Indéterminée'
    }

    private generateUsageIcon(id: string) : string[]
    {
        let _usageIcon: string[] = [];
    
        if(id !== undefined)
            _usageIcon = this.usageIcons.find(u => u.Id.toString() === id.toString())?.Label?.split('/');

        if(_usageIcon && _usageIcon.length > 0)
            return _usageIcon;
        else return ['question-circle'];
    }

    private addUsage(usageId: number) : void
    {
         if(this.allocationNode.value.Usage === usageId)
            this.allocationNode.value.Usage = undefined;
        else this.allocationNode.value.Usage = usageId;
    }

    private indexWidth: number = 0;
        
    private addSection(sections: Section<Period, Dictionary<IField[]>>[]) : void 
    {
        if(sections[0].Name == "Meter")
        {            
            this.form.Sections = this.form.Sections?.filter(s => s.Name != "Meter");
            this.form.Sections.push(...sections);
            this.meterSections = this.form != undefined ? this.form.Sections.filter(s => s.Name == "Meter") : [];
            this.loadSection(this.meterSections.findIndex(i => i.Value?.Selected === true))
        }
        else if (sections[0].Name == "Children")
        {
            this.form.Sections = this.form.Sections?.filter(s => s.Name != "Children");
            this.form.Sections.push(...sections);
            this.childMeterSections = this.form != undefined ? this.form.Sections.filter(s => s.Name == "Children") : [];
            this.loadChildSection(this.childMeterSections.findIndex(i => i.Value?.Selected === true));
        } 
    }

    /**
     * Supprimer une section
     * @param index 
     * @param sections 
     * @returns { void }
     */
    private deleteSection (index: number, sections: Section<Period, Dictionary<IField[]>>[], name: string) : void
    {
        let _formIndex: number = this.form.Sections.findIndex(u => u == sections[index]);
        this.form.Sections.splice(_formIndex, 1);

        if(name == "Meter")
        {
            this.meterSections = this.form != undefined ? this.form.Sections.filter(s => s.Name == "Meter") : [];
            this.loadSection(this.meterSections.findIndex(u => u.Value.Selected === true) !== -1 ? this.meterSections.findIndex(u => u.Value.Selected === true) : this.meterSections.length - 1);
        }
        else if (name == "Children")
        {
            this.childMeterSections = this.form != undefined ? this.form.Sections.filter(s => s.Name == "Children") : [];
            this.loadChildSection(this.childMeterSections.findIndex(u => u.Value.Selected === true) !== -1 ? this.childMeterSections.findIndex(u => u.Value.Selected === true) : this.childMeterSections.length - 1);
        }
    };

    /**
     * Genere les dates de début et de fin des sections
     * @param sections 
     * @returns { Section<Period, Dictionary<IField[]>>[] } : sections avec les dates générées
     */
    private generateDate(sections: Section<Period, Dictionary<IField[]>>[]) : Section<Period, Dictionary<IField[]>>[] 
    {
        sections = this.sortPeriod(sections);

        sections.forEach((section, index) => 
        {
            if(section.Value)
            {
                if(sections[index + 1] !== undefined)
                {
                    section.Value.EndDate = sections[index + 1]?.Value?.StartDate;
                }

                if(sections[index - 1] !== undefined)
                {
                    section.Value.StartDate = sections[index - 1]?.Value?.EndDate;
                }
            }
        })

        return sections;
    };

    /**
     * Tri les dates de début des sections
     * @param sections 
     * @returns { Section<Period, Dictionary<IField[]>>[] } : sections triées par date de début
     */
    private sortPeriod(sections: Section<Period, Dictionary<IField[]>>[]) : Section<Period, Dictionary<IField[]>>[] 
    {
        sections.sort((a,b) => 
        {  
            return new Date(a.Value?.StartDate).getTime() - new Date(b.Value?.StartDate).getTime();
        });

        return sections;
    };

    /**
     * Ajoute un sous-compteur
     * @param underMeterId 
     * @returns { void }
     */
    private addUnderMeter(underMeterId: string) : void
    {
        let _fields: IField[] = this.childMeterSections.find(u => u.Value.Selected == true).Fields[nodesField] as IField[];

        if(_fields.filter(u => (u as GraphNode).Id == underMeterId).length == 0 && underMeterId != this.NodeId)
        {
            let _allocation: TAllocation = { Id: (--this.indexAllocation).toString(), IsRecurring: false, Usage: null, Percentage: null, StartDay: null, StartMonth: null, EndDay: null, EndMonth: null } as TAllocation;
            _fields.push(new GraphNode<TAllocation>(underMeterId, ['i1'], ['o1'], 1, _allocation));
            this.loadChildSection();
        } 
        else 
        {
             this.$bvToast.toast(this.$t('SubMeterExist').toString(), {
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }
    }

     /**
     * Supprime un sous-compteur
     * @param underMeterId 
     * @returns { void }
     */
    private deleteUnderMeter(underMeterId: string) : void
    {
        let _fields: IField[] = this.childMeterSections.find(u => u.Value.Selected == true).Fields[nodesField] as IField[];
        if(_fields.filter(u => (u as GraphNode).Id == underMeterId).length != 0)
        {
            _fields.splice(_fields.findIndex(u => (u as GraphNode).Id == underMeterId), 1);
            this.loadChildSection();
        } 
    }

    /**
     * Initialise le graph et le noeud compteur
     * @returns { void }
     */
    private init() : void 
    {
        this.graph = new graph();

        let _node: TreeNode = this.$store.getters[MAIN_FILTER_TREE + "/Node"](this.NodeId);

        this.graph.createNode({
            id: "METER",
            x: ((this.columnWidth * 1) + 10 - this.columnWidth) + (this.columnWidth - 10) * 0.22,
            height: 65,
            width: this.columnWidth * 0.60,
            opacity: 1,
            inputs: ['i1'],
            outputs: ['o1', 'o2'],
            name: _node.Name,
            invariant: _node.Invariant,
            icon: _node.ObjectType,
            column: 1,
        });

        this.calculateYPos();
    }

    /**
     * Genere toutes les sections de la période
     * @param index Si load section est appelé avec un index, on charge la section à l'index, sinon toutes les sections sont chargées
     * @returns { void }
     */
    private loadSection(index?: number) : void 
    {
        this.meterSections.forEach(u => 
        {
            if(new Date(u.Value?.StartDate).getTime() === this.allocationUtils.NullDate.getTime())
                u.Value.StartDate = null;

            if(new Date(u.Value?.EndDate).getTime() === this.allocationUtils.NullDate.getTime())
                u.Value.EndDate = null;
        })

        this.meterSections = this.generateDate(this.meterSections);

        if(index !== undefined && this.meterSections[index] != undefined)
        {
            this.scrollMove = {};
            
            (this.meterSections as any as Section<Period, Dictionary<IField[]>>[]).forEach(section => 
            {
                if(section.Value)
                    section.Value.Selected = false;
            })

            this.meterSections[index].Value.Selected = true;
        }

        this.init();

        (this.meterSections.find(u => u.Value.Selected == true)?.Fields[nodesField] as GraphNode<TAllocation>[])?.filter(graphNode => graphNode.Column === 3).forEach(graphNode => 
        {
            if(graphNode?.Id)
            {
                let _node: TreeNode = this.$store.getters[MAIN_FILTER_TREE + "/Node"](graphNode.Id);
                this.graph.createNode({
                    id: graphNode.Id,
                    x: ((this.columnWidth * 3) + 10 - this.columnWidth) + (this.columnWidth - 10) * 0.22,
                    height: 65,
                    width: this.columnWidth * 0.50,
                    opacity: 1,
                    inputs: ['i1'],
                    outputs: ['o1'],
                    name: _node.Name,
                    invariant: _node.Invariant,
                    icon: _node.ObjectType,
                    column: 3
                });

                let graphEdges: GraphEdge[] = (this.meterSections.find(u => u.Value.Selected == true)?.Fields[edgesField] as GraphEdge[]).filter(graphEdge => graphEdge.To === graphNode.Id);
                let graphNodes: GraphNode[] = (this.meterSections.find(u => u.Value.Selected == true)?.Fields[nodesField] as GraphNode<TAllocation>[]).filter(u => 
                {
                    return u.Column === 2 && graphEdges.map(edge => edge.From).includes(u.Id);
                });

                graphNodes.sort((a, b) => { return b.Value.Percentage - a.Value.Percentage}).forEach(graphRepartition => {
                    let _currentYear: number = new Date().getFullYear();
                    let _endCurrentYear: number = new Date().getFullYear();
                    let _startDay: number = graphRepartition.Value.StartDay;
                    let _startMonth: number = graphRepartition.Value.StartMonth;
                    let _endDay: number = graphRepartition.Value.EndDay;
                    let _endMonth: number = graphRepartition.Value.EndMonth;

                    if(_startDay === 0 || _startMonth === 0 || _endDay === 0 || _endMonth === 0 || _startDay === null || _startMonth === null || _endDay === null || _endMonth === null)
                    {
                        _startDay = 1;
                        _startMonth = 1;
                        _endDay = 1;
                        _endMonth = 1;
                    }

                    if(_endDay === 1 && _endMonth === 1)
                        _endCurrentYear++;

                    _startMonth--;
                    _endMonth--;

                    let _startDate: Date = new Date(_currentYear, _startMonth, _startDay);
                    let _endDate: Date = new Date(_endCurrentYear, _endMonth, _endDay);

                    this.graph.createNode({
                        id: graphRepartition.Id,
                        x: ((this.columnWidth * 2) + 10 - this.columnWidth) + (this.columnWidth - 10) * 0.22,
                        height: 65,
                        width: this.columnWidth * 0.50,
                        opacity: 1,
                        inputs: ['i1'],
                        outputs: ['o1'],
                        column: 2,
                        Usage: graphRepartition.Value.Usage,
                        Percentage: graphRepartition.Value.Percentage,
                        IsRecurring: graphRepartition.Value.IsRecurring,
                        startDay: _startDay,
                        startMonth: _startMonth,
                        endDay: _endDay,
                        endMonth: _endMonth,
                        startDate: _startDate,
                        endDate: _endDate,
                    });
                })
            }
        });

        (this.meterSections.find(u => u.Value.Selected == true)?.Fields[edgesField] as GraphEdge[])?.forEach(GraphEdge => {
            this.graph.createEdge({
                from: GraphEdge.From,
                to: GraphEdge.To,
                fromPort: GraphEdge.FromPort,
                toPort: GraphEdge.ToPort,
                active: false,
                type: 'hsmooth'
            })
        });
    }

    /**
     * Charge les sections enfants
     * @param index 
     * @returns { void }
     */
    private loadChildSection(index?: number) : void 
    {
        this.childMeterSections.forEach(u => {
            if(new Date(u.Value?.StartDate).getTime() === this.allocationUtils.NullDate.getTime())
                u.Value.StartDate = null;

            if(new Date(u.Value?.EndDate).getTime() === this.allocationUtils.NullDate.getTime())
                u.Value.EndDate = null;
        })

        this.childMeterSections = this.generateDate(this.childMeterSections);

        if(index !== undefined){
            this.childMeterSections.forEach(u => {
                u.Value.Selected = false;
            })

            this.childMeterSections[index].Value.Selected = true;
        }
    }

    /**
     * Met à jour les noeuds de la section active
     * @param graphNode 
     * @returns { void }
     */
    private updateNode(graphNode: GraphNode<TAllocation>[]) : void
    {
        graphNode.forEach(x=> {
            let _index: number = (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).findIndex(u=> u.Id === x.Id);

            if (_index !== -1)
                (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).splice(_index, 1, x);
            else
                (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).push(x);
        })

        this.loadSection();
    }

    /**
     * Supprime un noeud du graph
     * @param id 
     * @returns { void }
     */
    private deleteNode(id: string) : void 
    {
        let _graphNode: GraphNode<TAllocation> = (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).find(u=>u.Id === id);
        let _index: number = (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).findIndex(u=>u === _graphNode);
        let _graphEdges: GraphEdge[] = (this.meterSections.find(u => u.Value.Selected == true).Fields[edgesField] as GraphEdge[]).filter(u=>u.From === _graphNode.Id || u.To === _graphNode.Id);

        (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).splice(_index, 1);
        
        _graphEdges.forEach(u => {
            if(u.From === _graphNode.Id)
            {
                let _consummerNode: GraphNode<TAllocation> = (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).find(x => x.Id === u.To);
                let _toEdges: GraphEdge[] = (this.meterSections.find(u => u.Value.Selected == true).Fields[edgesField] as GraphEdge[]).filter(w => w.To === _consummerNode.Id);

                if(_toEdges.length === 1)
                {
                    let _consummerNodeIndex: number = (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).findIndex(u => u === _consummerNode);
                    (this.meterSections.find(u => u.Value.Selected == true).Fields[nodesField] as GraphNode<TAllocation>[]).splice(_consummerNodeIndex, 1);
                }
            }

            let edgeIndex: number = (this.meterSections.find(u => u.Value.Selected == true).Fields[edgesField] as GraphEdge[]).findIndex(x=> x === u);
            (this.meterSections.find(u => u.Value.Selected == true).Fields[edgesField] as GraphEdge[]).splice(edgeIndex, 1);
        });

        this.loadSection();
    }

    @Getter('ObjectStore/GetUpdatedForms')
    private updatedForms!: string[];
    
    private resizeCanvas = null;

    /**
     * Gère le redimensionnement du canvas
     * @returns { void }
     */
    private callResize() : void 
    {
        // J'avoue j'ai demandé à GPT
        // Récupère la Hauteur de l'élement
        if ('ResizeObserver' in window && this.$refs.canvas) 
        {
            // Entries fait référence à l'élement envoyé dans l'observer
            this.resizeCanvas = new ResizeObserver(entries => {
                entries.forEach(entry => {

                    let { height, width } = entry.contentRect;
                    this.canvasHeight = height;
                    this.canvasWidth = width;
                    this.columnWidth = Math.round(width / 3);
                })
            });

            // L'élément envoyé est mon canvas
            this.resizeCanvas.observe(this.$refs.canvas);
        }
    }

    @Watch('canvasWidth')
    private callIndexWidth()
    {       
        this.getIndexWidth();
    }

    @Watch('canvasHeight')
    private calculateYPos() : void
    {
        for(let _column = 1; _column <= 3; _column++)
        {
            let _nodes: { id: string, x: number, y: number, height: number, width: number, column: number }[] = this.graph.nodes.filter(u => u.column === _column);
            let _numberNodes: number = _nodes.length;
            let _splitHeight: number = this.canvasHeight / 2;
            let _addScroll : number = this.scrollMove[_column]?? 0;

            _nodes.forEach((node, i) => 
            {
                let elem: HTMLElement = document.getElementById(node.id);
                if (elem) 
                {
                    let _nodeHeight: number = Number(elem.getAttribute('height'));
                    this.graph.updateNode(node, {y: _splitHeight - ((_nodeHeight * _numberNodes) / 2) + (_nodeHeight * i) + _addScroll});
                }
            });
        }
    }

    created() 
    {
        this.allocationUtils = new AllocationUtils(this.$i18n);

        /** Pour indiquer au watcher sur form de BaseObjectForm de ne pas se déclencher dès l'initialisation de la form */
        this.immediateFormWatcher = false;

        this.meterSections = this.form != undefined ? this.form.Sections.filter(s => s.Name == "Meter") : [];
        this.childMeterSections = this.form != undefined ? this.form.Sections.filter(s => s.Name == "Children") : [];

        this.checkWriteAction = this.$store.getters['CheckAction']('Write', 'ObjectSheet');
        this.checkDeleteAction = this.$store.getters['CheckAction']('Delete', 'ObjectSheet');
        this.checkAddAction = this.$store.getters['CheckAction']('Add', 'ObjectSheet');

        this.$store.dispatch("LoadListItems", [{ listName: 'UsageType' }, { listName: 'UsageTypeIcon' }]).then(response => {
            this.listUsages = this.$store.getters["GetListItems"]('UsageType');
            this.usageIcons = this.$store.getters["GetListItems"]('UsageTypeIcon');
        });
    }

    mounted() 
    {
        this.callResize()

        this.loadSection(this.meterSections.length - 1);
        this.loadChildSection(this.childMeterSections.length - 1);

        window.addEventListener("resize", this.changePos);
        window.addEventListener("fullscreen", this.changePos);
    }

    updated() 
    {
        this.changePos();
    }

    beforeDestroy() 
    {
        if (this.filterTreeBuilder)
            this.filterTreeBuilder.UnloadFilterTree();

        if (this.resizeCanvas) 
        {
            this.resizeCanvas.disconnect();
        }

        window.removeEventListener("resize", this.changePos);
        window.removeEventListener("fullscreen", this.changePos);
    }  
}

/** Clé du dictionnaire des Fields contenant les Nodes */
const nodesField: string = FieldTypeEnum[FieldTypeEnum.Node].toString();
/** Clé du dictionnaire des Fields contenant les Edges */
const edgesField: string = FieldTypeEnum[FieldTypeEnum.Edge].toString();

class TAllocation {
    Id: string;
    Usage: number;
    Percentage: number;
    StartDay?: number;
    StartMonth?: number;
    EndDay?: number;
    EndMonth?: number;
    IsRecurring?: boolean;
}

/** Implémentation de IConfigTree pour filtrer la liste des noeuds de l'arborescence à sa création spécifiquement pour Allocation */
class AllocationConfigTree implements IConfigTree {
    private objectTypes: string[] = undefined;

    public constructor(objectTypes: string[]) {
        this.objectTypes = objectTypes;
    }

    public Filter(treeNodes: TreeNode[], isHistoricMode : boolean): TreeNode[] {
        /** @todo réaliser les opérations de filtrage avec @slavina ici !!!! */
        return treeNodes;
    }

}

</script>

<style scoped>
    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) 
    {
        border-color: var(--Variant) !important;
        background-color: var(--Variant) !important;
    }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) 
    {
        background-color: var(--Variant) !important;
        border-color: var(--Variant) !important;
    }

    :deep(#formControlRange)
    {
        height: 8px;
        -webkit-appearance: none;
        appearance: none;
        background-color: var(--light);
        border-radius: 5px;
    }

    :deep(input[type=range]::-webkit-slider-thumb)
    {
        -webkit-appearance: none;
        border-radius: 100%;
        height: 20px;
        width: 20px;
        background: var(--secondary);
    }

    :deep(input[type="range"]::-moz-range-progress)
    {
        background-color: var(--secondary);
        height: 9px;
        border-radius: 9px;
    }

    :deep(#formControlRange:hover)
    {
        outline: none;
        box-shadow: 0 0 6px var(--secondary);
    }


    :deep(.heritage-modal) 
    {
        height: 100% !important;
        max-height: var(--fullHeight) !important;
        overflow: hide !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 1vh !important;
        padding-bottom: 1vh !important;
    }

    #modal 
    {
        position: absolute;
        top: 60px;
        right: 100px
    }

    :deep(#canvasAllocation .node .content)
    {
        background-color: #FFF;
        box-shadow: 0px 0px 10px 1px rgb(100, 100, 100, .5);
    }

    :deep(#canvasAllocation .edge)
    {
        stroke: rgb(117, 117, 117);
        stroke-linejoin: round;
        marker-start: none;
        marker-end: none;
        stroke-dasharray: 5px 10px;
        stroke-dashoffset: 1000;
        stroke-linecap: round;
        animation: dash 20s linear infinite;
    }
</style>

<style>
    @keyframes dash 
    {
        to 
        {
            stroke-dashoffset: 0;
        }
    }
</style>